module.exports = __webpack_public_path__ + "img/icon-arrow-right.edd12980.svg";